import { Injectable } from '@angular/core';
import { WebApiService } from 'src/app/shared/services/web-api.service';
import { PoTokenAuthService } from 'src/app/shared/services/po-token-auth.service';
import { RfqTokenAuthService } from 'src/app/shared/services/rfq-token-auth.service';
import { ServiceRfqTokenAuthService } from 'src/app/shared/services/service-rfq-token-auth.service';
import { ServicePoTokenAuthService } from 'src/app/shared/services/service-po-token-auth.service';

@Injectable({
  providedIn: 'root'
})
export class QuoteService {

  constructor(
    private webApiService: WebApiService,
    private poTokenAuth: PoTokenAuthService,
    private rfqTokenAuth: RfqTokenAuthService,
    private serviceRfqTokenAuth: ServiceRfqTokenAuthService,
    private servicePoTokenAuth: ServicePoTokenAuthService
  ) { }

  async fetchRfqDetails(params: any): Promise<any> {
    let apiUrl = `/quote/fetchRfqDetails`;
    return this.webApiService.postRequest<any>(apiUrl,params);
  }
  async fetchRfqDetailsByPoToken(params: any): Promise<any> {
    const apiUrl = `/quote/fetchRfqDetailsByPoToken`;
    const poId = this.poTokenAuth.getPoId();
    const requestBody = {
      ...params,
      ...(poId && !params?.purchaseOrderId ? { purchaseOrderId: poId } : {})
    };
    const options = this.poTokenAuth.buildAuthHeaders();
    return this.webApiService.postRequest<any>(apiUrl, requestBody, options);
  }

  async fetchRfqDetailsByRfqToken(params: any): Promise<any> {
    const apiUrl = `/quote/fetchRfqDetailsByRfqToken`;
    const rfqId = this.rfqTokenAuth.getRfqId();
    const requestBody = {
      ...params,
      ...(rfqId && !params?.rfqId ? { rfqId: rfqId } : {})
    };
    const options = this.rfqTokenAuth.buildAuthHeaders();
    return this.webApiService.postRequest<any>(apiUrl, requestBody, options);
  }
  async fetchRfqLineItemAttachments(params: any): Promise<any> {
    let apiUrl = `/quote/fetchRfqLineItemAttachments`;
    return this.webApiService.postRequest<any>(apiUrl,params);
  }

  async fetchRfqLineItemDetails(params: any): Promise<any> {
    let apiUrl = `/quote/fetchRfqLineItemDetails`;
    return this.webApiService.postRequest<any>(apiUrl,params);
  }

  async fetchRfqLineItemDetailsByRfqToken(params: any): Promise<any> {
    const apiUrl = `/quote/fetchRfqLineItemDetailsByRfqToken`;
    const options = this.rfqTokenAuth.buildAuthHeaders();
    return this.webApiService.postRequest<any>(apiUrl, params, options);
  }

  async fetchRfqLineItemAttachmentsByRfqToken(params: any): Promise<any> {
    const apiUrl = `/quote/fetchRfqLineItemAttachmentsByRfqToken`;
    const options = this.rfqTokenAuth.buildAuthHeaders();
    return this.webApiService.postRequest<any>(apiUrl, params, options);
  }

  fetchAllIncoterms(): Promise<any> {
    let apiUrl = `/quote/fetchAllIncoterms`;
    return this.webApiService.getRequest<any>(apiUrl);
  }

  fetchAllIncotermsByRfqToken(): Promise<any> {
    let apiUrl = `/quote/fetchAllIncotermsByRfqToken`;
    const options = this.rfqTokenAuth.buildAuthHeaders();
    return this.webApiService.getRequestWithOptions<any>(apiUrl, options);
  }

  fetchAllOfferedQuality(): Promise<any> {
    let apiUrl = `/quote/fetchAllOfferedQuality`;
    return this.webApiService.getRequest<any>(apiUrl);
  }

  fetchAllOfferedQualityByRfqToken(): Promise<any> {
    let apiUrl = `/quote/fetchAllOfferedQualityByRfqToken`;
    const options = this.rfqTokenAuth.buildAuthHeaders();
    return this.webApiService.getRequestWithOptions<any>(apiUrl, options);
  }

  fetchAllQuteAttachmentType(type: any): Promise<any> {
    let apiUrl = `/quote/fetchAllQuteAttachmentType/${type}`;
    return this.webApiService.getRequest<any>(apiUrl);
  }

  fetchAllQuteAttachmentTypeByRfqToken(type: any): Promise<any> {
    let apiUrl = `/quote/fetchAllQuteAttachmentTypeByRfqToken/${type}`;
    const options = this.rfqTokenAuth.buildAuthHeaders();
    return this.webApiService.getRequestWithOptions<any>(apiUrl, options);
  }
  
  fetchAllDeclineReason(): Promise<any> {
    let apiUrl = `/quote/fetchAllDeclineReason`;
    return this.webApiService.getRequest<any>(apiUrl);
  }

  fetchAllServiceDeclineReason(): Promise<any> {
    let apiUrl = `/services/quote/fetchAllServiceDeclineReason`;
    return this.webApiService.getRequest<any>(apiUrl);
  }

  fetchAllDeclineReasonByRfqToken(): Promise<any> {
    let apiUrl = `/quote/fetchAllDeclineReasonByRfqToken`;
    const options = this.rfqTokenAuth.buildAuthHeaders();
    return this.webApiService.getRequestWithOptions<any>(apiUrl, options);
  }

  getQuoteDraftData(tab:string,supplierId:number):Promise<any>{
    let apiUrl = `/quote/getQuoteDraftData/${tab}/${supplierId}`;
    return this.webApiService.getRequest<any>(apiUrl)
  }

  getQuoteDraftDataByRfqToken(tab:string, quoteId:number):Promise<any>{
    let apiUrl = `/quote/getQuoteDraftDataByRfqToken/${tab}/${quoteId}`;
    const options = this.rfqTokenAuth.buildAuthHeaders();
    return this.webApiService.getRequestWithOptions<any>(apiUrl, options);
  }
  

  saveQuoteAsDraft(params: any): Promise<any> {
    let apiUrl = `/quote/saveAsdraft`;
    return this.webApiService.postRequest<any>(apiUrl, params
    );
  }

  updateQuoteAsDraft(params: any): Promise<any> {
    let apiUrl = `/quote/updateQuoteDraft`;
    return this.webApiService.postRequest<any>(apiUrl, params
    );
  }

  getlastQuoteId():Promise<any>{
    let apiUrl = `/quote/getlastQuoteId`;
    return this.webApiService.getRequest<any>(apiUrl)
  }

  getlastQuoteIdByRfqToken():Promise<any>{
    let apiUrl = `/quote/getlastQuoteIdByRfqToken`;
    const options = this.rfqTokenAuth.buildAuthHeaders();
    return this.webApiService.getRequestWithOptions<any>(apiUrl, options);
  }

  getQuoteId(params: any): Promise<any> {
    let apiUrl = `/quote/getQuoteId`;
    return this.webApiService.postRequest<any>(apiUrl, params
    );
  }

  getQuoteIdByRfqToken(params: any): Promise<any> {
    const apiUrl = `/quote/getQuoteIdByRfqToken`;
    const rfqId = this.rfqTokenAuth.getRfqId();
    const supplierId = this.rfqTokenAuth.getSupplierId();
    const requestBody = {
      ...params,
      ...(rfqId && !params?.rfqId ? { rfqId: rfqId } : {}),
      ...(supplierId && !params?.supplierId ? { supplierId: supplierId } : {})
    };
    const options = this.rfqTokenAuth.buildAuthHeaders();
    return this.webApiService.postRequest<any>(apiUrl, requestBody, options);
  }

  saveQuoteAsDraftByRfqToken(params: any): Promise<any> {
    const apiUrl = `/quote/saveAsdraftByRfqToken`;
    const rfqId = this.rfqTokenAuth.getRfqId();
    const supplierId = this.rfqTokenAuth.getSupplierId();
    const requestBody = {
      ...params,
      ...(rfqId && !params?.rfqId ? { rfqId: rfqId } : {}),
      ...(supplierId && !params?.supplierId ? { supplierId: supplierId } : {})
    };
    const options = this.rfqTokenAuth.buildAuthHeaders();
    return this.webApiService.postRequest<any>(apiUrl, requestBody, options);
  }

  updateQuoteAsDraftByRfqToken(params: any): Promise<any> {
    const apiUrl = `/quote/updateQuoteDraftByRfqToken`;
    const rfqId = this.rfqTokenAuth.getRfqId();
    const supplierId = this.rfqTokenAuth.getSupplierId();
    const requestBody = {
      ...params,
      ...(rfqId && !params?.rfqId ? { rfqId: rfqId } : {}),
      ...(supplierId && !params?.supplierId ? { supplierId: supplierId } : {})
    };
    const options = this.rfqTokenAuth.buildAuthHeaders();
    return this.webApiService.postRequest<any>(apiUrl, requestBody, options);
  }

  deleteAttachment(attachmentArr: number[]):Promise<any>{
    const attachments = { attachmentArr };
    let apiUrl = `/quote/deleteAttachment`;
    return this.webApiService.postRequest<any>(apiUrl,attachments )
  }

  deleteAttachmentByRfqToken(attachmentArr: number[]):Promise<any>{
    const attachments = { attachmentArr };
    const apiUrl = `/quote/deleteAttachmentByRfqToken`;
    const options = this.rfqTokenAuth.buildAuthHeaders();
    return this.webApiService.postRequest<any>(apiUrl, attachments, options);
  }

 declineRfq(params:any): Promise<any> {
  let apiUrl = `/quote/declineRfq`;
  return this.webApiService.postRequest<any>(apiUrl, params
  );
}

 declineRfqByRfqToken(params:any): Promise<any> {
  const apiUrl = `/quote/declineRfqByRfqToken`;
  const options = this.rfqTokenAuth.buildAuthHeaders();
  return this.webApiService.postRequest<any>(apiUrl, params, options);
}


async fetchRfqPreviewDetails(params: any): Promise<any> {
  let apiUrl = `/quote/fetchRfqPreviewDetailsByRfqIdAndBuyerId`;
  return this.webApiService.postRequest<any>(apiUrl,params);
}

async fetchRfqPreviewDetailsByRfqToken(params: any): Promise<any> {
  let apiUrl = `/quote/fetchRfqPreviewDetailsByRfqToken`;
  const options = this.rfqTokenAuth.buildAuthHeaders();
  return this.webApiService.postRequest<any>(apiUrl, params, options);
}

async fetchQuotePreviewDetails(params: any): Promise<any> {
  let apiUrl = `/quote/fetchQuotePreviewDetailsByQuoteIdAndSupplierId`;
  return this.webApiService.postRequest<any>(apiUrl,params);
}

// MPS-274 | Akarsh Singh | 2026-08-21
// Purchase price history for the quote under review. Loaded separately from the
// quote itself so the page never waits on it.
async fetchPreviousPurchasePrices(params: any): Promise<any> {
  let apiUrl = `/quote/fetchPreviousPurchasePrices`;
  return this.webApiService.postRequest<any>(apiUrl, params);
}

async fetchQuotePreviewDetailsByRfqToken(params: any): Promise<any> {
  let apiUrl = `/quote/fetchQuotePreviewDetailsByRfqToken`;
  const options = this.rfqTokenAuth.buildAuthHeaders();
  return this.webApiService.postRequest<any>(apiUrl, params, options);
}

async sendQuotationAcknowledgment(params:any):Promise<any>{
    let apiUrl = `/quote/sendQuotationAcknowledgment`;
    return this.webApiService.postRequest<any>(apiUrl,params)
  }

async sendServiceQuotationAcknowledgment(params:any):Promise<any>{
    let apiUrl = `/services/rfq/sendServiceQuotationAcknowledgment`;
    return this.webApiService.postRequest<any>(apiUrl,params)
  }

async sendQuotationAcknowledgmentByRfqToken(params:any):Promise<any>{
    const apiUrl = `/quote/sendQuotationAcknowledgmentByRfqToken`;
    const rfqId = this.rfqTokenAuth.getRfqId();
    const supplierId = this.rfqTokenAuth.getSupplierId();
    const requestBody = {
      ...params,
      ...(rfqId && !params?.rfqId ? { rfqId: rfqId } : {}),
      ...(supplierId && !params?.supplierId ? { supplierId: supplierId } : {})
    };
    const options = this.rfqTokenAuth.buildAuthHeaders();
    return this.webApiService.postRequest<any>(apiUrl, requestBody, options)
  }

async sendDeclineRfqAcknowledgment(params:any):Promise<any>{
    let apiUrl = `/quote/sendDeclineRfqAcknowledgment`;
    return this.webApiService.postRequest<any>(apiUrl,params)
  }

async sendDeclineRfqAcknowledgmentByRfqToken(params:any):Promise<any>{
    const apiUrl = `/quote/sendDeclineRfqAcknowledgmentByRfqToken`;
    const rfqId = this.rfqTokenAuth.getRfqId();
    const supplierId = this.rfqTokenAuth.getSupplierId();
    const requestBody = {
      ...params,
      ...(rfqId && !params?.rfqId ? { rfqId: rfqId } : {}),
      ...(supplierId && !params?.supplierId ? { supplierId: supplierId } : {})
    };
    const options = this.rfqTokenAuth.buildAuthHeaders();
    return this.webApiService.postRequest<any>(apiUrl,requestBody,options)
  }


async sendAcknowledgeRfqAcknowledgment(params:any):Promise<any>{
    let apiUrl = `/quote/sendAcknowledgeRfqAcknowledgment`;
    return this.webApiService.postRequest<any>(apiUrl,params)
  }

async sendAcknowledgeRfqAcknowledgmentByRfqToken(params:any):Promise<any>{
    const apiUrl = `/quote/sendAcknowledgeRfqAcknowledgmentByRfqToken`;
    const rfqId = this.rfqTokenAuth.getRfqId();
    const supplierId = this.rfqTokenAuth.getSupplierId();
    const requestBody = {
      ...params,
      ...(rfqId && !params?.rfqId ? { rfqId: rfqId } : {}),
      ...(supplierId && !params?.supplierId ? { supplierId: supplierId } : {})
    };
    const options = this.rfqTokenAuth.buildAuthHeaders();
    return this.webApiService.postRequest<any>(apiUrl,requestBody,options)
  }
async fetchServiceRfqDetails(params: any): Promise<any> {
  let apiUrl = `/services/rfq/fetchServiceRfqDetailPageData`;
  return this.webApiService.postRequest<any>(apiUrl, params);
}

async fetchServiceRfqLineItemAttachments(params: any): Promise<any> {
  let apiUrl = `/services/rfq/fetchServiceRfqLineItemAttachments`;
  return this.webApiService.postRequest<any>(apiUrl, params);
}

async acknowledgeServiceRfq(params: any): Promise<any> {
  let apiUrl = `/services/rfq/acknowledgeServiceRfq`;
  return this.webApiService.postRequest<any>(apiUrl, params);
}

async declineServiceRfq(params: any): Promise<any> {
  let apiUrl = `/services/rfq/declineServiceRfq`;
  return this.webApiService.postRequest<any>(apiUrl, params);
}

getServiceQuoteId(params: any): Promise<any> {
  let apiUrl = `/services/rfq/getServiceQuoteId`;
  return this.webApiService.postRequest<any>(apiUrl, params);
}

getLastServiceQuoteId(): Promise<any> {
  let apiUrl = `/services/rfq/getLastServiceQuoteId`;
  return this.webApiService.getRequest<any>(apiUrl);
}

saveServiceQuoteAsDraft(params: any): Promise<any> {
  let apiUrl = `/services/rfq/saveServiceQuoteAsDraft`;
  return this.webApiService.postRequest<any>(apiUrl, params);
}

updateServiceQuoteDraft(params: any): Promise<any> {
  let apiUrl = `/services/rfq/updateServiceQuoteDraft`;
  return this.webApiService.postRequest<any>(apiUrl, params);
}

getServiceQuoteDraftData(tab: string, quoteId: number): Promise<any> {
  let apiUrl = `/services/rfq/getServiceQuoteDraftData/${tab}/${quoteId}`;
  return this.webApiService.getRequest<any>(apiUrl);
}

fetchServiceRfqLineItemsForQuote(params: any): Promise<any> {
  let apiUrl = `/services/rfq/fetchServiceRfqLineItemsForQuote`;
  return this.webApiService.postRequest<any>(apiUrl, params);
}

async fetchQuoteListByRfqId(params: any): Promise<any> {
  let apiUrl = `/quote/fetchQuoteListByRfqId`;
  return this.webApiService.postRequest<any>(apiUrl,params);
}

async fetchQuoteDetailsBundle(params: { quoteId: number; supplierId: number; rfqId: number }): Promise<any> {
  const apiUrl = `/quote/fetchQuoteDetailsBundle`;
  return this.webApiService.postRequest<any>(apiUrl, params);
}

async quoteOperationsByBUyer(params: any): Promise<any> {
  let apiUrl = `/quote/quoteOperationsByBUyer`;
  return this.webApiService.postRequest<any>(apiUrl,params);
}

async importQuoteByExcel(params: any): Promise<any> {
  let apiUrl = `/quote/importQuoteByExcel`;
  return this.webApiService.postRequest<any>(apiUrl,params);
}

fetchAllCurrency(): Promise<any> {
  let apiUrl = `/quote/fetchAllCurrency`;
  return this.webApiService.getRequest<any>(apiUrl);
}

// =============================================
// Service RFQ Token-Based Methods
// =============================================

async fetchServiceRfqDetailsByServiceRfqToken(params: any): Promise<any> {
  let apiUrl = `/services/rfq/token/fetchServiceRfqDetailPageData`;
  const serviceRfqId = this.serviceRfqTokenAuth.getServiceRfqId();
  const supplierId = this.serviceRfqTokenAuth.getSupplierId();
  const requestBody = {
    ...params,
    ...(serviceRfqId && !params?.serviceRfqId ? { serviceRfqId: serviceRfqId } : {}),
    ...(supplierId && !params?.supplierId ? { supplierId: supplierId } : {})
  };
  const options = this.serviceRfqTokenAuth.buildAuthHeaders();
  return this.webApiService.postRequest<any>(apiUrl, requestBody, options);
}

async fetchServiceRfqLineItemAttachmentsByServiceRfqToken(params: any): Promise<any> {
  let apiUrl = `/services/rfq/token/fetchServiceRfqLineItemAttachments`;
  const serviceRfqId = this.serviceRfqTokenAuth.getServiceRfqId();
  const requestBody = {
    ...params,
    ...(serviceRfqId && !params?.serviceRfqId ? { serviceRfqId: serviceRfqId } : {})
  };
  const options = this.serviceRfqTokenAuth.buildAuthHeaders();
  return this.webApiService.postRequest<any>(apiUrl, requestBody, options);
}

async acknowledgeServiceRfqByServiceRfqToken(params: any): Promise<any> {
  let apiUrl = `/services/rfq/token/acknowledgeServiceRfq`;
  const serviceRfqId = this.serviceRfqTokenAuth.getServiceRfqId();
  const supplierId = this.serviceRfqTokenAuth.getSupplierId();
  const requestBody = {
    ...params,
    ...(serviceRfqId && !params?.serviceRfqId ? { serviceRfqId: serviceRfqId } : {}),
    ...(supplierId && !params?.supplierId ? { supplierId: supplierId } : {})
  };
  const options = this.serviceRfqTokenAuth.buildAuthHeaders();
  return this.webApiService.postRequest<any>(apiUrl, requestBody, options);
}

async declineServiceRfqByServiceRfqToken(params: any): Promise<any> {
  let apiUrl = `/services/rfq/token/declineServiceRfq`;
  const serviceRfqId = this.serviceRfqTokenAuth.getServiceRfqId();
  const supplierId = this.serviceRfqTokenAuth.getSupplierId();
  const requestBody = {
    ...params,
    ...(serviceRfqId && !params?.serviceRfqId ? { serviceRfqId: serviceRfqId } : {}),
    ...(supplierId && !params?.supplierId ? { supplierId: supplierId } : {})
  };
  const options = this.serviceRfqTokenAuth.buildAuthHeaders();
  return this.webApiService.postRequest<any>(apiUrl, requestBody, options);
}

getLastServiceQuoteIdByServiceRfqToken(): Promise<any> {
  let apiUrl = `/services/rfq/token/getLastServiceQuoteId`;
  const options = this.serviceRfqTokenAuth.buildAuthHeaders();
  return this.webApiService.getRequestWithOptions<any>(apiUrl, options);
}

getServiceQuoteIdByServiceRfqToken(params: any): Promise<any> {
  let apiUrl = `/services/rfq/token/getServiceQuoteId`;
  const serviceRfqId = this.serviceRfqTokenAuth.getServiceRfqId();
  const supplierId = this.serviceRfqTokenAuth.getSupplierId();
  const requestBody = {
    ...params,
    ...(serviceRfqId && !params?.serviceRfqId ? { serviceRfqId: serviceRfqId } : {}),
    ...(supplierId && !params?.supplierId ? { supplierId: supplierId } : {})
  };
  const options = this.serviceRfqTokenAuth.buildAuthHeaders();
  return this.webApiService.postRequest<any>(apiUrl, requestBody, options);
}

saveServiceQuoteAsDraftByServiceRfqToken(params: any): Promise<any> {
  let apiUrl = `/services/rfq/token/saveServiceQuoteAsDraft`;
  const options = this.serviceRfqTokenAuth.buildAuthHeaders();
  return this.webApiService.postRequest<any>(apiUrl, params, options);
}

generateSupplierServiceRfqAttachmentByServiceRfqToken(serviceRfqId: number, supplierId: number): Promise<any> {
  let apiUrl = `/services/rfq/token/generateSupplierServiceRfqAttachment`;
  const options = this.serviceRfqTokenAuth.buildAuthHeaders();
  return this.webApiService.postRequest<any>(apiUrl, { serviceRfqId, supplierId }, options);
}

fetchServiceRfqLineItemsForQuoteByServiceRfqToken(params: any): Promise<any> {
  let apiUrl = `/services/rfq/token/fetchServiceRfqLineItemsForQuote`;
  const serviceRfqId = this.serviceRfqTokenAuth.getServiceRfqId();
  const supplierId = this.serviceRfqTokenAuth.getSupplierId();
  const requestBody = {
    ...params,
    ...(serviceRfqId && !params?.serviceRfqId ? { serviceRfqId: serviceRfqId } : {}),
    ...(supplierId && !params?.supplierId ? { supplierId: supplierId } : {})
  };
  const options = this.serviceRfqTokenAuth.buildAuthHeaders();
  return this.webApiService.postRequest<any>(apiUrl, requestBody, options);
}

getServiceQuoteDraftDataByServiceRfqToken(tab: string, quoteId: number): Promise<any> {
  let apiUrl = `/services/rfq/token/getServiceQuoteDraftData/${tab}/${quoteId}`;
  const options = this.serviceRfqTokenAuth.buildAuthHeaders();
  return this.webApiService.getRequestWithOptions<any>(apiUrl, options);
}

updateServiceQuoteDraftByServiceRfqToken(params: any): Promise<any> {
  let apiUrl = `/services/rfq/token/updateServiceQuoteDraft`;
  const options = this.serviceRfqTokenAuth.buildAuthHeaders();
  return this.webApiService.postRequest<any>(apiUrl, params, options);
}

fetchAllServiceDeclineReasonByServiceRfqToken(): Promise<any> {
  let apiUrl = `/services/rfq/token/fetchAllServiceDeclineReason`;
  const options = this.serviceRfqTokenAuth.buildAuthHeaders();
  return this.webApiService.getRequestWithOptions<any>(apiUrl, options);
}

fetchAllQuteAttachmentTypeByServiceRfqToken(type: any): Promise<any> {
  let apiUrl = `/services/rfq/token/fetchAllQuteAttachmentType/${type}`;
  const options = this.serviceRfqTokenAuth.buildAuthHeaders();
  return this.webApiService.getRequestWithOptions<any>(apiUrl, options);
}

getTaxDetailsBySupplierByServiceRfqToken(): Promise<any> {
  let apiUrl = `/services/rfq/token/getTaxDetailsBySupplier`;
  const options = this.serviceRfqTokenAuth.buildAuthHeaders();
  return this.webApiService.postRequest<any>(apiUrl, {}, options);
}

fetchSupplierSetupByServiceRfqToken(setupType: string): Promise<any> {
  let apiUrl = `/services/rfq/token/fetchSupplierSetup/${setupType}`;
  const options = this.serviceRfqTokenAuth.buildAuthHeaders();
  return this.webApiService.getRequestWithOptions<any>(apiUrl, options);
}

fetchAllIncotermsByServiceRfqToken(): Promise<any> {
  let apiUrl = `/services/rfq/token/fetchAllIncoterms`;
  const options = this.serviceRfqTokenAuth.buildAuthHeaders();
  return this.webApiService.getRequestWithOptions<any>(apiUrl, options);
}

fetchAllIncotermsBySupplierIdByServiceRfqToken(): Promise<any> {
  let apiUrl = `/services/rfq/token/fetchAllIncotermsBySupplierId`;
  const options = this.serviceRfqTokenAuth.buildAuthHeaders();
  return this.webApiService.getRequestWithOptions<any>(apiUrl, options);
}

fetchAllOfferedQualityByServiceRfqToken(): Promise<any> {
  let apiUrl = `/services/rfq/token/fetchAllOfferedQuality`;
  const options = this.serviceRfqTokenAuth.buildAuthHeaders();
  return this.webApiService.getRequestWithOptions<any>(apiUrl, options);
}

fetchAllCountryDetailsByServiceRfqToken(): Promise<any> {
  let apiUrl = `/services/rfq/token/fetchAllCountryDetails`;
  const options = this.serviceRfqTokenAuth.buildAuthHeaders();
  return this.webApiService.getRequestWithOptions<any>(apiUrl, options);
}

getBulkAttachmentUrlsByServiceRfqToken(body: any): Promise<any> {
  let apiUrl = `/services/rfq/token/getBulkAttachmentUrls`;
  const options = this.serviceRfqTokenAuth.buildAuthHeaders();
  return this.webApiService.postRequest<any>(apiUrl, body, options);
}

getAllCurrenciesByFliterKeyValueByServiceRfqToken(searchKey: string, page: number, limit: number): Promise<any> {
  let apiUrl = `/services/rfq/token/getAllCurrenciesByFliterKeyValue?searchKey=${searchKey}&page=${page}&limit=${limit}`;
  const options = this.serviceRfqTokenAuth.buildAuthHeaders();
  return this.webApiService.getRequestWithOptions<any>(apiUrl, options);
}

deleteAttachmentByServiceRfqToken(attachmentArr: number[]): Promise<any> {
  let apiUrl = `/services/rfq/token/deleteAttachment`;
  const options = this.serviceRfqTokenAuth.buildAuthHeaders();
  return this.webApiService.postRequest<any>(apiUrl, { attachmentArr }, options);
}

getAllPaymentTermsByServiceRfqToken(): Promise<any> {
  let apiUrl = `/services/rfq/token/getAllPaymentTerms`;
  const options = this.serviceRfqTokenAuth.buildAuthHeaders();
  return this.webApiService.getRequestWithOptions<any>(apiUrl, options);
}

getSupplierUpdateDataByServiceRfqToken(): Promise<any> {
  let apiUrl = `/services/rfq/token/getSupplierUpdateData`;
  const options = this.serviceRfqTokenAuth.buildAuthHeaders();
  return this.webApiService.getRequestWithOptions<any>(apiUrl, options);
}

sendServiceQuotationAcknowledgmentByServiceRfqToken(params: any): Promise<any> {
  let apiUrl = `/services/rfq/token/sendServiceQuotationAcknowledgment`;
  const options = this.serviceRfqTokenAuth.buildAuthHeaders();
  return this.webApiService.postRequest<any>(apiUrl, params, options);
}

fetchAllDeclineReasonByServiceRfqToken(): Promise<any> {
  let apiUrl = `/services/rfq/token/fetchAllDeclineReason`;
  const options = this.serviceRfqTokenAuth.buildAuthHeaders();
  return this.webApiService.getRequestWithOptions<any>(apiUrl, options);
}

getAllAutocompleteSupplierProductByServiceRfqToken(searchKey: string, page: number, limit: number): Promise<any> {
  let apiUrl = `/services/rfq/token/getAllAutocompleteSupplierProduct?searchKey=${searchKey}&page=${page}&limit=${limit}`;
  const options = this.serviceRfqTokenAuth.buildAuthHeaders();
  return this.webApiService.getRequestWithOptions<any>(apiUrl, options);
}

getBuyerTaxDetailsByServiceRfqToken(params: any): Promise<any> {
  let apiUrl = `/services/rfq/token/getBuyerTaxDetails`;
  const options = this.serviceRfqTokenAuth.buildAuthHeaders();
  return this.webApiService.postRequest<any>(apiUrl, params, options);
}

addTaxDetailsBySupplierByServiceRfqToken(reqBody: any): Promise<any> {
  let apiUrl = `/services/rfq/token/addTaxDetailsBySupplier`;
  const options = this.serviceRfqTokenAuth.buildAuthHeaders();
  return this.webApiService.postRequest<any>(apiUrl, reqBody, options);
}

getAllRegionsByFliterKeyValueByServiceRfqToken(countryCode: string): Promise<any> {
  let apiUrl = `/services/rfq/token/getAllRegionsByFliterValue?countryCode=${encodeURIComponent(countryCode)}`;
  const options = this.serviceRfqTokenAuth.buildAuthHeaders();
  return this.webApiService.getRequestWithOptions<any>(apiUrl, options);
}

fetchServiceRfqDetailsForExcelByServiceRfqToken(
  serviceRfqId: number,
  supplierId: number
): Promise<any> {
  let apiUrl = `/services/rfq/token/fetchServiceRfqDetailsForExcel`;

  const options = this.serviceRfqTokenAuth.buildAuthHeaders();
  
  return this.webApiService.postRequest<any>(
    apiUrl,
    {
      serviceRfqId,
      supplierId
    },
    options
  );

}

// =============================================
// Service PO Token-Based Methods
// =============================================

fetchServicePurchaseOrderByServicePoToken(params: any): Promise<any> {
  let apiUrl = `/services/rfq/poToken/fetchServicePurchaseOrder`;
  const poId = this.servicePoTokenAuth.getPoId();
  const supplierId = this.servicePoTokenAuth.getSupplierId();
  const requestBody = {
    ...params,
    ...(poId && !params?.servicePurchaseOrderId ? { servicePurchaseOrderId: poId } : {}),
    ...(supplierId && !params?.supplierId ? { supplierId: supplierId } : {})
  };
  const options = this.servicePoTokenAuth.buildAuthHeaders();
  return this.webApiService.postRequest<any>(apiUrl, requestBody, options);
}

generateServicePoPdfByServicePoToken(params: any): Promise<any> {
  let apiUrl = `/services/rfq/poToken/generateServicePoPdf`;
  const options = this.servicePoTokenAuth.buildAuthHeaders();
  return this.webApiService.postRequest<any>(apiUrl, params, options);
}

getLastAcceptedServiceOrderIdByServicePoToken(): Promise<any> {
  let apiUrl = `/services/rfq/poToken/getLastAcceptedServiceOrderId`;
  const options = this.servicePoTokenAuth.buildAuthHeaders();
  return this.webApiService.getRequestWithOptions<any>(apiUrl, options);
}

fetchAllServiceRejectionReasonByServicePoToken(): Promise<any> {
  let apiUrl = `/services/rfq/poToken/fetchAllServiceRejectionReason`;
  const options = this.servicePoTokenAuth.buildAuthHeaders();
  return this.webApiService.getRequestWithOptions<any>(apiUrl, options);
}

sendServicePOConfirmationAcknowledgementByServicePoToken(params: any): Promise<any> {
  let apiUrl = `/services/rfq/poToken/sendServicePOConfirmationAcknowledgement`;
  const options = this.servicePoTokenAuth.buildAuthHeaders();
  return this.webApiService.postRequest<any>(apiUrl, params, options);
}

sendServicePORejectionAcknowledgementByServicePoToken(params: any): Promise<any> {
  let apiUrl = `/services/rfq/poToken/sendServicePORejectionAcknowledgement`;
  const options = this.servicePoTokenAuth.buildAuthHeaders();
  return this.webApiService.postRequest<any>(apiUrl, params, options);
}

fetchServicePoAttachmentExcelDataByPoToken(params: any): Promise<any> {
  let apiUrl = `/services/rfq/poToken/fetchServicePoAttachmentExcelData`;
  const poId = this.servicePoTokenAuth.getPoId();
  const supplierId = this.servicePoTokenAuth.getSupplierId();
  const requestBody = {
    ...params,
    ...(poId && !params?.servicePurchaseOrderId ? { servicePurchaseOrderId: poId } : {}),
    ...(supplierId && !params?.supplierId ? { supplierId: supplierId } : {})
  };
  const options = this.servicePoTokenAuth.buildAuthHeaders();
  return this.webApiService.postRequest<any>(apiUrl, requestBody, options);
}

// =============================================
// Requote - product/service
// =============================================


reQuote(params: any): Promise<any> {
  let apiUrl = `/quote/reQuote`;
  return this.webApiService.postRequest<any>(apiUrl, params
  );
  
}

reQuoteService(params: any): Promise<any> {
  let apiUrl = `/services/rfq/reQuoteService`;
  return this.webApiService.postRequest<any>(apiUrl, params
  ); 

}
}





  



